import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import { Navigate } from 'react-router-dom';
import moment from "moment";
import {
  TextInput,
} from "components/Input/Index.js";
import DateInput from "components/Input/DateInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { markets } from "variables/markets";
import { statusData, energyData } from "variables/lists/markets";
import { postMarket } from "services/ConfigServices";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "61.5ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "61.5ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function CreateMarketDialog(props) {
  const [name, setName] = useState("");
  const [groups, setGroups] = useState([]);
  const [status, setStatus] = useState("creation");
  const [datebegin, setDatebegin] = useState("");
  const [dateend, setDateend] = useState("");
  const [energy, setEnergy] = useState("electricity");
  const [marketnumber, setMarketnumber] = useState("");

  const [redirState, setRedirState] = useState(false);
  const [marketId, setMarketId] = useState("");

  const [buttonDisabled, setButtonDisabled] = useState(true);

  useEffect(() => {
    if (
      name.length > 0 &&
      groups.length > 0
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [name, groups]);

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/markets/selectedmarket/",
        state: { marketId, marketName: name },
      }}
    />
  );

  const handleSubmit = async (event) => {
    createMarket(event);
  };

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleStatusChange = (event) => { setStatus(event.target.value); };
  const handleDatebeginChange = (event) => { setDatebegin(event.target.value); };
  const handleDateendChange = (event) => { setDateend(event.target.value); };
  const handleEnergyChange = (event) => { setEnergy(event.target.value); };
  const handleMarketnumberChange = (event) => { setMarketnumber(event.target.value); };


  let url = postMarket();
  const createMarket = async (event) => {
    await axios
      .post(
        url,
        {
          general: {
            groups: [groups],
            name,
            status,
            datebegin,
            dateend,
            energy,
            marketnumber,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        setMarketId(res.data.id);
        if (res.status == 200) {
          setNotification("success", "Marché créé");
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
    setRedirState(true);
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <div>
              <TextInput
                inputTitle={markets.general.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={markets.general.marketnumber}
                textInput={marketnumber}
                handleTextInputChange={handleMarketnumberChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={markets.general.energy}
                selectValue={energy}
                handleSelectValueChange={handleEnergyChange}
                data={energyData}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={markets.general.status}
                selectValue={status}
                handleSelectValueChange={handleStatusChange}
                data={statusData}
              />
            </div>
            <div>
              <DateInput
                inputTitle={markets.general.datebegin}
                dateInput={datebegin}
                handleDateInputChange={handleDatebeginChange}
              />
            </div>
            <div>
              <DateInput
                inputTitle={markets.general.dateend}
                dateInput={dateend}
                handleDateInputChange={handleDateendChange}
              />
            </div>
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Créer
            </Button>
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div className={classes.treeVisible}>
              <TreeLabel>Choix du périmètre</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={setGroups}
                  userSelectedIds={groups}
                />
              </ImageList>
            </div>
          </GridItem>
        </GridContainer>
      </form>
      {redirecting}
    </>
  );
}

export default CreateMarketDialog;
